var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-radio-group',{on:{"change":_vm.change},model:{value:(_vm.radio),callback:function ($$v) {_vm.radio=$$v},expression:"radio"}},[_vm._l((_vm.dicItems),function(dic,dicIndex){return [_c('el-radio',{key:dicIndex,attrs:{"label":dic.value}},[_vm._v(" "+_vm._s(dic.label)+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }